<div class="left-sidebar">
  <!-- Icon strip -->
  <div class="icon-strip">
    <div class="close-row">
      <button
        type="button"
        class="close-btn"
        title="Hide Tools Panel"
        (click)="onClose()"
      >
        <svg class="chevrons-left" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="m11 17-5-5 5-5" />
          <path d="m18 17-5-5 5-5" />
        </svg>
      </button>
    </div>
    <button
      *ngFor="let tool of tools"
      type="button"
      class="tool-btn"
      [class.active]="activeTool === tool.id"
      (click)="setActiveTool(tool.id)"
    >
      <span class="tool-icon" [ngSwitch]="tool.id">
        <!-- Find Clip (ai) -->
        <ng-container *ngSwitchCase="'ai'">
          <svg class="icon-svg icon-svg-20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip-broadcast-left)">
              <path d="M7.14286 0H2.14286C0.961429 0 0 0.961429 0 2.14286V7.14286C0 8.32429 0.961429 9.28571 2.14286 9.28571H7.14286C8.32429 9.28571 9.28571 8.32429 9.28571 7.14286V2.14286C9.28571 0.961429 8.32429 0 7.14286 0ZM7.85714 7.14286C7.85714 7.53643 7.53643 7.85714 7.14286 7.85714H2.14286C1.74929 7.85714 1.42857 7.53643 1.42857 7.14286V2.14286C1.42857 1.74929 1.74929 1.42857 2.14286 1.42857H7.14286C7.53643 1.42857 7.85714 1.74929 7.85714 2.14286V7.14286ZM7.14286 10.7143H2.14286C0.961429 10.7143 0 11.6757 0 12.8571V17.8571C0 19.0386 0.961429 20 2.14286 20H7.14286C8.32429 20 9.28571 19.0386 9.28571 17.8571V12.8571C9.28571 11.6757 8.32429 10.7143 7.14286 10.7143ZM7.85714 17.8571C7.85714 18.2507 7.53643 18.5714 7.14286 18.5714H2.14286C1.74929 18.5714 1.42857 18.2507 1.42857 17.8571V12.8571C1.42857 12.4636 1.74929 12.1429 2.14286 12.1429H7.14286C7.53643 12.1429 7.85714 12.4636 7.85714 12.8571V17.8571ZM17.8571 10.7143H12.8571C11.6757 10.7143 10.7143 11.6757 10.7143 12.8571V17.8571C10.7143 19.0386 11.6757 20 12.8571 20H17.8571C19.0386 20 20 19.0386 20 17.8571V12.8571C20 11.6757 19.0386 10.7143 17.8571 10.7143ZM18.5714 17.8571C18.5714 18.2507 18.2507 18.5714 17.8571 18.5714H12.8571C12.4636 18.5714 12.1429 18.2507 12.1429 17.8571V12.8571C12.1429 12.4636 12.4636 12.1429 12.8571 12.1429H17.8571C18.2507 12.1429 18.5714 12.4636 18.5714 12.8571V17.8571ZM10.7143 4.28571C10.7143 3.89143 11.0343 3.57143 11.4286 3.57143H14.6429V0.714286C14.6429 0.32 14.9629 0 15.3571 0C15.7514 0 16.0714 0.32 16.0714 0.714286V3.57143H19.2857C19.68 3.57143 20 3.89143 20 4.28571C20 4.68 19.68 5 19.2857 5H16.0714V8.57143C16.0714 8.96571 15.7514 9.28571 15.3571 9.28571C14.9629 9.28571 14.6429 8.96571 14.6429 8.57143V5H11.4286C11.0343 5 10.7143 4.68 10.7143 4.28571Z" fill="currentColor"/>
            </g>
            <defs>
              <clipPath id="clip-broadcast-left">
                <rect width="20" height="20" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </ng-container>
        <!-- Media -->
        <ng-container *ngSwitchCase="'media'">
          <svg class="icon-svg" viewBox="0 0 21 14" fill="currentColor" fill-rule="evenodd" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.160,11.177 C19.938,11.307 19.695,11.373 19.451,11.373 C19.209,11.373 18.965,11.307 18.744,11.178 L15.537,9.299 C15.537,9.299 13.622,8.157 13.567,8.112 L13.567,5.886 C13.622,5.841 15.537,4.700 15.537,4.700 L18.743,2.821 C19.188,2.561 19.717,2.562 20.160,2.821 C20.603,3.081 20.868,3.546 20.868,4.066 L20.868,9.933 C20.868,10.452 20.603,10.918 20.160,11.177 ZM19.166,4.566 L15.537,6.693 L15.537,7.306 L19.166,9.432 L19.166,4.566 ZM13.567,1.999 L2.809,1.999 L2.809,11.999 L13.567,11.999 L13.567,9.335 C13.622,9.380 15.537,10.522 15.537,10.522 L15.537,13.999 L0.839,13.999 L0.839,-0.001 L15.537,-0.001 L15.537,3.379 C15.537,3.379 13.622,4.521 13.567,4.566 L13.567,1.999 Z"/>
          </svg>
        </ng-container>
        <!-- Transcript & Subtitles -->
        <ng-container *ngSwitchCase="'transcript'">
          <span class="transcript-icon">
            <svg class="icon-svg" fill="none" viewBox="0 0 21.5 21.5" stroke="currentColor" stroke-width="1.5">
              <path d="M0.75 10.75C0.75 6.03596 0.75 3.67893 2.21447 2.21447C3.67893 0.75 6.03596 0.75 10.75 0.75C15.464 0.75 17.8211 0.75 19.2855 2.21447C20.75 3.67893 20.75 6.03596 20.75 10.75C20.75 15.464 20.75 17.8211 19.2855 19.2855C17.8211 20.75 15.464 20.75 10.75 20.75C6.03596 20.75 3.67893 20.75 2.21447 19.2855C0.75 17.8211 0.75 15.464 0.75 10.75Z" />
            </svg>
            <span class="cc-text">cC</span>
          </span>
        </ng-container>
        <!-- Graphics -->
        <ng-container *ngSwitchCase="'graphics'">
          <svg class="icon-svg" viewBox="0 0 22 22" fill="currentColor" fill-rule="evenodd" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.742784,10.25904 L8.964864,12.21936 L11.782464,7.70064 L15.360384,13.43952 L5.760384,13.43952 L7.742784,10.25904 Z M4.8,15.36 L21.12,15.36 L21.12,17.28 L4.8,17.28 C3.74112,17.28 2.88,16.41888 2.88,15.36 L2.88,6.72 L4.8,6.72 L4.8,15.36 Z M16.32,14.4 L16.32,5.76 L0,5.76 L0,3.84 L16.32,3.84 C17.37888,3.84 18.24,4.70112 18.24,5.76 L18.24,14.4 L16.32,14.4 Z M2.88,2.88 L2.88,0 L4.8,0 L4.8,2.88 L2.88,2.88 Z M16.32,21.12 L16.32,18.24 L18.24,18.24 L18.24,21.12 L16.32,21.12 Z"/>
          </svg>
        </ng-container>
        <!-- Text – classic serif T, twice thinner -->
        <ng-container *ngSwitchCase="'text'">
          <svg class="icon-svg" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 5L5 5 19 5 20 5 20 6 19 6 13 6 13 19 14 20 10 20 11 19 11 6 5 6 4 6z"/>
          </svg>
        </ng-container>
        <span *ngSwitchDefault></span>
      </span>
      <span class="tool-label">{{ tool.label }}</span>
    </button>
  </div>
  <!-- Panel content -->
  <div class="panel-container" [class.panel-container--overflow-visible]="activeTool === 'transcript' && transcriptStylePanelOpen">
    <ng-container [ngSwitch]="activeTool">
      <evrideo-clipping-studio-find-clip-panel
        *ngSwitchCase="'ai'"
        (segmentAdded)="segmentAdded.emit($event)"
      ></evrideo-clipping-studio-find-clip-panel>
      <evrideo-clipping-studio-media-panel
        *ngSwitchCase="'media'"
        (addToTimeline)="addToTimeline.emit($event)"
      ></evrideo-clipping-studio-media-panel>
      <evrideo-clipping-studio-transcript-subtitles-panel
        *ngSwitchCase="'transcript'"
        (stylePanelOpenChange)="transcriptStylePanelOpen = $event"
      ></evrideo-clipping-studio-transcript-subtitles-panel>
      <evrideo-clipping-studio-graphics-panel *ngSwitchCase="'graphics'" (addGfxToTimeline)="addGfxToTimeline.emit($event)" (updateTimelineGfxParamsRequested)="updateTimelineGfxParamsRequested.emit($event)"></evrideo-clipping-studio-graphics-panel>
      <evrideo-clipping-studio-text-panel *ngSwitchCase="'text'"></evrideo-clipping-studio-text-panel>
    </ng-container>
  </div>
</div>
